import ManagedTable, { ManagedColumn, ManagedTableProps } from '../../../common/table/ManagedTable';
import useWindowDimensions from '../../../common/hooks/useWindowDimensions';
import React from 'react';
import { ScenarioAttributesDto } from '../../../model/CORE';
import { CheckCircleFilled } from '@ant-design/icons';

export const SCENARIO_SELECTED_COLUMN = new ManagedColumn<ScenarioAttributesDto>(
    '',
    '2em',
    () => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

const ScenarioTable = (props: ManagedTableProps<ScenarioAttributesDto>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <ManagedTable<ScenarioAttributesDto> fontSize={fontSize} {...props} />;
};

export default ScenarioTable;
